import { render, staticRenderFns } from "./UIColorPicker.vue?vue&type=template&id=c82efa1c&scoped=true"
import script from "./UIColorPicker.vue?vue&type=script&lang=js"
export * from "./UIColorPicker.vue?vue&type=script&lang=js"
import style0 from "./UIColorPicker.vue?vue&type=style&index=0&id=c82efa1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82efa1c",
  null
  
)

export default component.exports